<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { authHeader } from "../../../helpers/auth-header";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import ListingTable from "@/components/listings/listing-table";

export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        ListingTable,
    },
    data() {
        return {
            title: "Timeslot Category",
            items: [
                {
                    text: "Timeslot Category"
                },
            ],
            filter: {
                name: ''
            },
            fields: [
                { key: "action" },
                { key: "id", sortable: true, label: "ID" },
                { key: "name", sortable: true, label: "Name" },
                { key: "status", sortable: true, label: "Status" },
            ]
        };
    },
    computed: {

    },
    watch: {

    },
    async mounted() {
        //
    },
    methods: {
        deleteRecord(id) {
            const deleteCallback = async () => {
                await axios.delete(`${process.env.VUE_APP_APIURL}/timeslot-category/${id}`, {
                    headers: authHeader(),
                });
                this.filterTable();
                this.$refs.confirmationModal.closeModal();
                this.$refs.messageModal.showModal('The record has been deleted');
            }
            this.$refs.confirmationModal.showModal(`Confirm delete category (ID: ${id})?`, deleteCallback);
        },

        setAdminView(filter) {
            this.filter = Object.assign(this.filter, filter);
        },

        filterTable() {
            const filter = this.filter;
            this.$refs.listingTable.filterTable(filter);
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body pt-0">
                        <div class="row mt-2 ml-0">
                            <router-link class="btn btn-success mb-2" :to="{name: 'Timeslot Category Form', params: {id: 'add'}}"><i class="mdi mdi-plus mr-2"></i> Add Timeslot Category</router-link>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm-12 col-md-4 col-lg-3 mt-2">
                                <input type="text" class="form-control" placeholder="Search" v-model="filter.name"
                                    v-on:keyup.enter="filterTable" />
                            </div>
                            <div class="col">
                                <a href="javascript:void(0);" class="btn btn-success mt-2" @click="filterTable">
                                    Filter
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="pl-4 pr-4">
                        <ListingTable ref="listingTable" :fields="fields" :setAdminView="setAdminView" path="timeslot-category" listName="timeslot_categories">
                            <template v-slot:cell(status)="row">
                                <div class="badge font-size-12" :class="{
                                    'badge-soft-danger': row.value == 0,
                                    'badge-soft-success': row.value == 1,
                                }">{{ row.value == 1 ? 'Active' : 'Inactive' }}</div>
                            </template>
                            <template v-slot:cell(action)="{ item }">
                                <router-link class="mr-3 text-primary" :to="{name: 'Timeslot Category Form', params: {id: item.id}}"><i class="mdi mdi-pencil font-size-18" v-b-tooltip.hover title="Edit"></i></router-link>
                                <a href="javascript:void(0);" class="text-danger" v-b-tooltip.hover title="Delete"
                                    @click="deleteRecord(item.id)">
                                    <i class="mdi mdi-trash-can font-size-18"></i>
                                </a>
                            </template>
                        </ListingTable>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>